import { firestore } from '@breakroom-nx/apis';
import { createApi, fakeBaseQuery } from '@reduxjs/toolkit/query/react';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';

import {
  User,
  Notification,
  getChatRoom,
  Room,
  getUserData,
} from '@breakroom-nx/classes';

export const updateAPI = createApi({
  reducerPath: 'updateApi',
  baseQuery: fakeBaseQuery(),
  keepUnusedDataFor: 60,
  endpoints: (builder) => ({
    getNotificationData: builder.query<
      { user?: User; room?: Room } | undefined,
      Notification
    >({
      queryFn: async (notification) => {
        try {
          // console.info(`[UPDATE API]: Getting notification data...`);

          const notificationData: { user?: User; room?: Room } = {};

          // Get User Info
          if (notification.notificationCreator) {
            // console.log(
            //   `Notification Creator: [${notification.notificationCreator}]`
            // );
            const user = await getUserData(notification.notificationCreator);
            if (user) {
              notificationData.user = user;
            } else {
              notificationData.user = undefined;
            }
          }

          // Get Room Info
          if (notification.roomBeingInvitedTo) {
            // console.log(
            //   `Notification Room Being: [${notification.roomBeingInvitedTo}]`
            // );

            const room = await getChatRoom(notification.roomBeingInvitedTo);
            if (room) {
              notificationData.room = room;
            } else {
              notificationData.room = undefined;
            }
          }

          return { data: notificationData };
        } catch (err) {
          // console.log(`[UPDATE API] (ERROR) ${err}`);
          return { error: err };
        }
      },
    }),
    // Get Online Team Members
    getOnlineTeamMembers: builder.query<(User | undefined)[], undefined>({
      queryFn: async (und) => {
        try {
          // console.info(`[UPDATE API]: Getting team members`);

          let teamMembers: (User | undefined)[] = [];
          const teamMembersPath = `team`;
          const teamMembersCollection = collection(firestore, teamMembersPath);
          const friendRequestsQuery = query(teamMembersCollection);

          const querySnapshot = await getDocs(friendRequestsQuery);
          if (!querySnapshot.empty) {
            const promises = querySnapshot.docs.map(async (doc) => {
              // Fetch each user
              // console.log(`Doc ID: ${doc.id}`);
              const user = await getUserData(doc.id);
              if (user) {
                return user;
              } else {
                return undefined;
              }
            });
            teamMembers = await Promise.all(promises);
            // console.log(
            //   `[USER API]: Number of team members retrieved: ${teamMembers.length}`
            // );
          }
          return { data: teamMembers };
        } catch (err) {
          // console.log(`[UPDATE API] (ERROR) ${err}`);
          return { error: err };
        }
      },
    }),
  }),
});

export const { useGetOnlineTeamMembersQuery, useGetNotificationDataQuery } =
  updateAPI;
